<template>
  <div v-if="info" id="common-patient-info" class="inner-content pb-2">
    <Spinner :isLoading="isLoading" />
    <h2 class="font-weight-bold mb-3">{{ $t('patient_information') }}</h2>
    <div class="patient-info-area clearfix">
      <div class="patient-pic">
        <p>
          <img class="image" v-if="info.photo_access_url" :src="info.photo_access_url" alt width="50" />
          <img class="image" v-else src="/images/no-image.png" alt width="50"/>
        </p>
      </div>
      <div class="patient-info">
        <ul class="p-sub-info">
          <li>{{ getChildName }}</li>
          <li>{{ $t('gender_colon') }} {{ gender }}</li>
          <li>{{ $t('age_colon') }}{{ $tc('age_ages', age) }}</li>
          <li class="patient-common-form">
            <p class="float-left">患者名：</p>
            <input v-if="isRegister1"
              type="text"
              placeholder=""
              v-model="info.name_for_doctor"
              class="style-input"
            >
            <p class="float-left" v-else>{{ info.name_for_doctor }}</p>
            <div class="style-button" :style="[$t('__locale') === 'en' && !oldNameForDoctor ? {'width': '85px'} : {'width': '60px'}]">
              <a style="text-decoration: none;" href="javascript:">
                <p v-if="isRegister1" @click="submitPatientName()">
                  {{ oldNameForDoctor ? $t('patient_info_button.save') : $t('patient_info_button.register') }}
                </p>
                <p v-else @click="isRegister1 = true">
                  {{ $t('patient_info_button.edit') }}
                </p>
              </a>
            </div>
          </li>
          <li class="patient-common-form mr-0">
            <p class="float-left">患者ID：</p>
            <input v-if="isRegister2"
              type="text"
              placeholder=""
              v-model="info.patient_id_for_dr"
              class="style-input"
            >
            <p class="float-left" v-else>{{ info.patient_id_for_dr }}</p>
            <div class="style-button" :style="[$t('__locale') === 'en' && !oldPatientIdForDr ? {'width': '85px'} : {'width': '60px'}]">
              <a style="text-decoration: none;" href="javascript:">
                <p v-if="isRegister2" @click="submitHospitalId()">
                  {{ oldPatientIdForDr ? $t('patient_info_button.save') : $t('patient_info_button.register') }}
                </p>
                <p v-else @click="isRegister2 = true">
                  {{ $t('patient_info_button.edit') }}
                </p>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <b-modal id="modal-validate-error" centered :hide-header="true" :hide-footer="true">
      <div class="modal-inner">
        <div class="modal-panel-group clearfix">
          <div class="modal-inner">
            <p class="modal-ttl" style="fontSize: 24px; color: red">エラー</p>
            <form action="" method="">
                <div class="modal-ttl">
                    <p>{{ errorMessage }}</p>
                </div>
                <div class="modal-btn-area clearfix">
                  <div class="btn-base pos-center"><a href="javascript:;" @click="onClick()" class="modal-close"><p>OK</p></a></div>
                </div>
            </form>
        </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Spinner from "@/js/components/Spinner"
import moment from "moment"

export default {
  data() {
    return {
      isLoading: true,
      shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
      activePage: 'graph',
      errorMessage: '',
      isRegister1: false,
      isRegister2: false,
      oldNameForDoctor: null,
      oldPatientIdForDr: null,
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      info: state => state.patient.info,
      errorMsg: state => state.patient.errorMsg,
      viewedHistories: state => state.patient.viewedHistories,
      otpAccessToken: state => state.otp.otpAccessToken,
      otpLoading: state => state.otp.otpLoading,
      doctorInfo: state => state.auth.doctorInfo,
      listMedicines: state => state.medicine.medicines
    }),
    medicines() {
      const medicineInfo = this.listMedicines.filter((item) => item.medicine_record.length > 0)
      return medicineInfo.map((item, index) => {
        const medicines = item.medicine_record.map((record) => {
          return record.medicine_name + (record.total_ingredient_amount ? '【'+ record.total_ingredient_amount + record.ingredient_unit +'】' : '')
        })
        return {
          date: moment(item.medicine_start_date).format('YYYY/MM/DD'),
          name: medicines.reduce((a,b) => a + this.$t('comma') + b)
        }
      })
    },
    gender() {
      return this.info.gender === 0 ? this.$t('male') : this.info.gender === 1 ? this.$t('female') : this.$t('not_identify')
    },
    age() {
      return moment().diff(moment(new Date(this.info.birthday)), "years")
    },
    getChildName() {
      if(this.$store.state.auth.typeOfUser === 'pharmacy') {
        return this.viewedHistories.length > 0 ? this.viewedHistories.find((o) => { return o["child_id"] === this.$route.params.childId })?.name : ''
      } else {
        return this.info.name
      }
    }
  },
  watch: {
  },
  async mounted() {
    if(!this.$route.params.childId){
      if (!this.otpAccessToken) {
        await this.$store.dispatch("patient/setPatientInfo", '')
        this.isLoading = false
      }
      let params = {
        one_time_access_key: this.otpAccessToken,
        hospital_master_id: this.$store.state.auth.doctorInfo?.hospital_master_id
      };
      if (!this.otpLoading) {
        await this.$store.dispatch("patient/getInfo", { params: params })
      }
    } else {
      await this.$store.dispatch("patient/setPatientInfo", '')
      await this.$store.dispatch("patient/getInfoByChildId", this.$route.params.childId)
    }
    this.isLoading = false
    this.$emit('loaded')
    const commonElResizeHandler = function (entries) {
      let minWidthOfPatientCommonToChangeClass = 567
      let padding = 20
      let targetElement = null
      for (let entry of entries) {
        targetElement = (entry.contentRect.width + padding * 2) <= minWidthOfPatientCommonToChangeClass ? entry.target.querySelectorAll('.float-left') : entry.target.querySelectorAll('.float-none')
        for(let el of targetElement) {
          el.className = (entry.contentRect.width + padding * 2) <= minWidthOfPatientCommonToChangeClass ? 'float-none' : 'float-left'
        }

      }
    }
    const commonElResizeObserver = new ResizeObserver(commonElResizeHandler)
    commonElResizeObserver.observe(document.querySelector("#common-patient-info"))
    this.checkPatientNameForDr()
    this.checkPatientIdForDr()
  },
  methods: {
    onShowPage(val) {
      this.activePage = val
      this.$emit('activePage', val)
      const event = val === 'graph' ? { event: this.$t('seizure_status_graph_by_seizure_type'), event_category: this.$t('patient_information'), event_label: this.$t('seizure_status_graph_by_seizure_type') }
                              : { event: this.$t('video'), event_category: this.$t('patient_information'), event_label: this.$t('video') }
      this.eventTracking(event)
    },
    onSeizureTypeSetting() {
       this.$bvModal.show('modal-seizure-type')
    },
    onCancel() {
      this.$bvModal.hide('modal-seizure-type')
    },
    async submitHospitalId() {
      if (this.info.patient_id_for_dr.length > 50) {
        this.errorMessage = '文字数は50文字以内で入力してください'
        this.$bvModal.show('modal-validate-error')
        return
      } else {
        this.isLoading = true
        String.prototype.toHalfWidth = function() {
          return this.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)});
        };
        this.info.patient_id_for_dr = this.info.patient_id_for_dr.toHalfWidth()
        await this.doctorUpdatePatient(false)
        this.checkPatientIdForDr()
        this.isLoading = false
      }
    },
    onClick() {
      this.name = this.info.name_for_doctor
      this.$bvModal.hide('modal-validate-error')
    },
    async submitPatientName() {
      if (this.info.name_for_doctor.length > 100) {
        this.errorMessage = '文字数は100文字以内で入力してください'
        this.$bvModal.show('modal-validate-error')
        return
      } else {
        this.isLoading = true
         await this.doctorUpdatePatient(true)
        this.checkPatientNameForDr()
        this.isLoading = false
      }
    },
    async doctorUpdatePatient(patientName) {
      await this.$store.dispatch("patient/drPatientName", {
        childId: this.info.id,
        patient_name: this.info.name_for_doctor,
        patient_id: this.info.patient_id_for_dr,
        update_patient_name: patientName ?? false
      })
    },
    checkPatientNameForDr() {
      this.isRegister1 = this.info.name_for_doctor ? false : true
      this.oldNameForDoctor = this.info.name_for_doctor
    },
    checkPatientIdForDr() {
      this.isRegister2 = this.info.patient_id_for_dr ? false: true
      this.oldPatientIdForDr = this.info.patient_id_for_dr
    }
  },
}
</script>

<style lang="css">
  .image {
    height: 50px;
    border-radius:50%;
  }
  .style-button {
    font-size: 0.8rem;
    text-align: center;
    box-sizing: border-box;
    background: #ff8ea1;
    border-radius: 20px;
    padding: 5px 15px;
    margin-left: 10px;
    width: 60px;
    height: 34px;
    float: right;
  }
  .style-button p{
    color: white;
    font-weight: 50;
    width: 100%;
    line-height: 24px;
  }
  .style-input {
    border: 1px solid;
    border-color: #cccccc;
    line-height: 30px;
    margin-top: -3px;
  }
  @media screen and (max-width: 1280px) {
    .style-input {
      line-height: 24px;
      width: 100px;
      height: 30px !important;
    }
  }
</style>